import { AddOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"
import { Button } from "@/components/common/Button"
import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface NoProductTestsAlertProps {
  onAdd: () => void
}

export const NoProductTestsAlert: FC<NoProductTestsAlertProps> = ({ onAdd }) => {
  const { hasPermissions } = usePermissionManager()

  return (
    <InformationMissingAlert
      title='No test results have been added.'
      description='Add test templates in order to add actual test results for a Certificate of Analysis.'
      action={
        hasPermissions([PermissionActionType.TEST_TEMPLATE_MAINTENANCE]) && (
          <Button
            appearance='outlined'
            size='small'
            className='self-center'
            startIcon={<AddOutlined />}
            onClick={onAdd}
          >
            Test Data
          </Button>
        )
      }
    />
  )
}
